<template>
  <div class="container pb-4 pt-4 order-accident">
    <div class="row mb-3">
      <div class="col-12">
        <h1 class="page-title mb-2" v-if="offerInfo">Оформлення страховки від {{ offerInfo.companyNamePublic }}</h1>
        <div class="text-muted small mb-2">Панель управління / Нещасний випадок / Пропозиції / Оформлення страховки</div>
        <a href="#" class="font-weight-bold text-primary" @click.prevent="$router.push({ name: 'accidentList' })">
          <i class="fa fa-angle-left mr-1"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 4L6 8L10 12" stroke="#0A77FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
         Повернутися до вибору пропозицій </i>
        </a>
      </div>
    </div>

    <div class="row" v-if="offerInfo && searchInfo">
      <div class="col-lg-8">

        <!-- Info Client -->
        <div class="order__block mb-4">
          <div class="order__block-header text-center py-2">
            <strong>Інформація про клієнта</strong>
          </div>
          <div class="p-4 d-flex justify-content-between align-items-center flex-wrap">
            <div class="custom-control custom-checkbox mb-2">
              <input type="checkbox" class="custom-control-input" id="newClient" v-model="payer.isNewClient">
              <label class="custom-control-label" for="newClient">Новий клієнт</label>
            </div>
            <div class="custom-control custom-checkbox mb-2">
              <input type="checkbox" class="custom-control-input" id="regularClient" v-model="payer.isRegularClient">
              <label class="custom-control-label" for="regularClient">Постійний клієнт</label>
            </div>
            <div class="custom-control custom-checkbox mb-2">
              <input type="checkbox" class="custom-control-input" id="publicPerson" v-model="payer.isPublicPerson">
              <label class="custom-control-label" for="publicPerson">Публічна особа</label>
            </div>
            <div class="custom-control custom-checkbox mb-2">
              <input type="checkbox" class="custom-control-input" id="nationalMinority" v-model="payer.isNationalMinority">
              <label class="custom-control-label" for="nationalMinority">Національна меншина</label>
            </div>
          </div>
        </div>

        <!-- Payer Info Block -->
        <div class="order__block mb-4">
          <div class="order__block-header text-center py-2">
            <strong>Введіть дані страхувальника</strong>
          </div>
          <div class="p-4">
            <div class="row mb-3">
              <div class="col-12">
                <div class="fill-btn-element d-flex align-items-center">
                  <div class="icon mr-2">
                    <button @click.prevent="fillClientData()" class="btn p-0" style="width: 53px; height: 35px; border: 1px solid #ced4da; border-radius: 4px; display: flex; align-items: center; justify-content: center;">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                           xmlns:xlink="http://www.w3.org/1999/xlink">
                        <rect width="32" height="32" fill="url(#pattern3)"/>
                        <defs>
                          <pattern id="pattern3" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_561_1706" transform="scale(0.01)"/>
                          </pattern>
                          <image id="image0_561_1706" width="100" height="100"
                                 xlink:href="data:image/png;base64,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"/>
                        </defs>
                      </svg>
                    </button>
                  </div>
                  <i class="icon question" data-html="true" data-placement="bottom"
                     data-select="true" data-toggle="tooltip" title="Заповнення форми"></i>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3 inn-block" style="position: relative;">
                <input
                  type="text"
                  :class="['form-control inn-field', {'is-invalid': payerErrorTaxNumber || (submitCheck && !payer.identificationCode && !payer.withoutIdentificationCode)}]"
                  v-model="payer.identificationCode"
                  placeholder="ІПН"
                  v-mask="'##########'"
                  maxlength="10"
                  :disabled="payer.withoutIdentificationCode"
                />
                <div v-if="isLoadInsuredsList" class="load-insured-list spinner-border spinner-border-sm" style="top: 12px; position: absolute; right: 25px;" role="status"></div>
                <div v-if="insuredsList['payer'] && insuredsList['payer'].length > 0" class="autocomplete-inn" style="display: block !important; position: absolute; top: 38px; left: 15px; width: calc(100% - 30px); z-index: 1050; background: #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border: 1px solid #ced4da; border-radius: 4px; max-height: 250px; overflow-y: auto;">
                  <div @mousedown.prevent="selectInsuredInfo(insured)" class="inn-items p-2 border-bottom" style="cursor: pointer;" v-for="insured in insuredsList['payer']" :key="insured.id">
                      <div><b>ІПН:</b> {{insured.identification_number}}</div>
                      <div><b>ПІБ:</b> {{insured.fio}}</div>
                  </div>
                </div>
                <div class="custom-control custom-checkbox mt-1">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="payerWithoutInn"
                    v-model="payer.withoutIdentificationCode"
                    @change="onPayerWithoutInnChange"
                  />
                  <label class="custom-control-label" for="payerWithoutInn" style="font-size: 13px;">
                    Відсутній ІПН
                  </label>
                </div>
                <small class="text-danger d-block" v-if="submitCheck && !payer.identificationCode && !payer.withoutIdentificationCode">
                  Вкажіть ІПН або оберіть "Відсутній ІПН"
                </small>
                <small class="text-danger d-block" v-if="payerErrorTaxNumber">
                  ІПН та Дата народження не співпадають
                </small>
              </div>
              <div class="col-md-6 mb-3 surname-block" style="position: relative;">
                <input
                  type="text"
                  :class="['form-control surname-field', {'is-invalid': submitCheck && !payer.surname}]"
                  v-model="payer.surname"
                  placeholder="Прізвище"
                />
                <div v-if="isLoadInsuredsListBySurname" class="load-insured-list spinner-border spinner-border-sm" style="top: 12px; position: absolute; right: 25px;" role="status"></div>
                <div v-if="insuredsListBySurname['payer'] && insuredsListBySurname['payer'].length > 0" class="autocomplete-surname" style="display: block !important; position: absolute; top: 38px; left: 15px; width: calc(100% - 30px); z-index: 1050; background: #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.15); border: 1px solid #ced4da; border-radius: 4px; max-height: 250px; overflow-y: auto;">
                  <div @mousedown.prevent="selectInsuredInfo(insured)" class="inn-items p-2 border-bottom" style="cursor: pointer;" v-for="insured in insuredsListBySurname['payer']" :key="insured.id">
                      <div><b>ІПН:</b> {{insured.identification_number}}</div>
                      <div><b>ПІБ:</b> {{insured.fio}}</div>
                  </div>
                </div>
                <small class="text-danger d-block" v-if="submitCheck && !payer.surname">
                  Вкажіть прізвище
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  :class="['form-control', {'is-invalid': submitCheck && !payer.name}]"
                  v-model="payer.name"
                  placeholder="Ім'я"
                />
                <small class="text-danger d-block" v-if="submitCheck && !payer.name">
                  Вкажіть ім'я
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <input type="text" class="form-control" v-model="payer.patronymic" placeholder="Ім'я по батькові" />
              </div>
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  :class="['form-control', {'is-invalid': (submitCheck && !payer.dateBirth) || (isInsuredSame && payerErrorTaxNumber)}]"
                  v-model="payer.dateBirth"
                  placeholder="ДД.ММ.РРРР"
                  v-mask="'##.##.####'"
                  :disabled="isInsuredSame && !!calcBirthDate"
                  :readonly="isInsuredSame && !!calcBirthDate"
                  :style="(isInsuredSame && calcBirthDate) ? 'background-color: #f8f9fa; cursor: not-allowed;' : ''"
                  :title="(isInsuredSame && calcBirthDate) ? 'Дата народження зафіксована з розрахунку калькулятора' : ''"
                />
                <small v-if="isInsuredSame && calcBirthDate" class="text-muted" style="font-size: 11px;">
                  Зафіксовано з калькулятора
                </small>
                <small class="text-danger d-block" v-if="submitCheck && !payer.dateBirth">
                  Вкажіть дату народження
                </small>
                <small class="text-danger d-block" v-if="isInsuredSame && payerErrorTaxNumber">
                  ІПН та Дата народження не співпадають
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <citySearch
                  :citySelect="payerCitySelect"
                  :cityStore="payerCityStore"
                />
                <small class="text-danger d-block" v-if="submitCheck && !payer.city">
                  Оберіть місто
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <input type="text" class="form-control" v-model="payer.street" placeholder="Вулиця" />
              </div>
              <div class="col-md-6 mb-3">
                <div class="row">
                  <div class="col-6"><input type="text" class="form-control" v-model="payer.house" placeholder="Номер будинку" /></div>
                  <div class="col-6"><input type="text" class="form-control" v-model="payer.apartment" placeholder="Номер квартири" /></div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  :class="['form-control', {'is-invalid': submitCheck && (!payer.phone || payer.phone.length < 19)}]"
                  v-model="payer.phone"
                  placeholder="+38 (0##) ###-##-##"
                  v-mask="'+38 (0##) ###-##-##'"
                />
                <small class="text-danger d-block" v-if="submitCheck && (!payer.phone || payer.phone.length < 19)">
                  Вкажіть коректний номер телефону (+38 (0XX) XXX-XX-XX)
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  :class="['form-control', {'is-invalid': submitCheck && !payer.mail}]"
                  v-model="payer.mail"
                  placeholder="Email на який отримаєте поліс"
                />
                <small class="text-danger d-block" v-if="submitCheck && !payer.mail">
                  Вкажіть email для отримання поліса
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- Document Block -->
        <div class="order__block mb-4">
          <div class="order__block-header text-center py-2">
            <strong>Заповніть один з документів страхувальника</strong>
          </div>
          <div class="p-4">
            <DocumentsBlock
              ref="documentsBlock"
              :productType="12"
              :offerInfo="offerInfo"
              :searchInfo="searchInfo"
              :documentation="payer.documentation"
              :submitCheck="submitCheck"
              :withoutIdentificationCode="payer.withoutIdentificationCode"
              :dateBirth="payer.dateBirth"
              :privileges="false"
            ></DocumentsBlock>
          </div>
        </div>

        <!-- Insured Person -->
        <div class="order__block mb-4">
          <div class="order__block-header text-center py-2">
            <strong>Введіть дані застрахованої особи</strong>
          </div>
          <div class="p-4">
            <div class="custom-control custom-checkbox mb-3" :title="isInsuredChild ? 'Застрахована особа є неповнолітньою (до 18 років), страхувальник має бути повнолітнім' : ''">
              <input type="checkbox" class="custom-control-input" id="isInsuredSame" v-model="isInsuredSame" :disabled="isInsuredChild">
              <label class="custom-control-label font-weight-bold" for="isInsuredSame" :class="{'text-muted': isInsuredChild}">Страхувальник є застрахованою особою</label>
            </div>

            <div v-if="isInsuredChild" class="alert alert-info py-2 px-3 mb-4" style="font-size: 13px;">
              <i class="fa fa-info-circle mr-1"></i>
              Застрахована особа є неповнолітньою (до 18 років), тому страхувальником договору має бути повнолітня особа (один з батьків або законний представник).
            </div>

            <div v-if="!isInsuredSame" class="row mt-3">
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  :class="['form-control', {'is-invalid': insuredErrorTaxNumber || (submitCheck && !isInsuredChild && !insured.identificationCode && !insured.withoutIdentificationCode)}]"
                  v-model="insured.identificationCode"
                  placeholder="ІПН"
                  v-mask="'##########'"
                  maxlength="10"
                  :disabled="insured.withoutIdentificationCode"
                />
                <div class="custom-control custom-checkbox mt-1">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="insuredWithoutInn"
                    v-model="insured.withoutIdentificationCode"
                    @change="onInsuredWithoutInnChange"
                  />
                  <label class="custom-control-label" for="insuredWithoutInn" style="font-size: 13px;">
                    Відсутній ІПН (для дітей або нерезидентів)
                  </label>
                </div>
                <small class="text-danger d-block" v-if="submitCheck && !isInsuredChild && !insured.identificationCode && !insured.withoutIdentificationCode">
                  Вкажіть ІПН або оберіть "Відсутній ІПН"
                </small>
                <small class="text-danger d-block" v-if="insuredErrorTaxNumber">
                  ІПН та Дата народження не співпадають
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  :class="['form-control', {'is-invalid': submitCheck && !insured.surname}]"
                  v-model="insured.surname"
                  placeholder="Прізвище"
                />
                <small class="text-danger d-block" v-if="submitCheck && !insured.surname">
                  Вкажіть прізвище
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  :class="['form-control', {'is-invalid': submitCheck && !insured.name}]"
                  v-model="insured.name"
                  placeholder="Ім'я"
                />
                <small class="text-danger d-block" v-if="submitCheck && !insured.name">
                  Вкажіть ім'я
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <input type="text" class="form-control" v-model="insured.patronymic" placeholder="Ім'я по батькові" />
              </div>
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  :class="['form-control', {'is-invalid': (submitCheck && !insured.dateBirth) || insuredErrorTaxNumber}]"
                  v-model="insured.dateBirth"
                  placeholder="ДД.ММ.РРРР"
                  v-mask="'##.##.####'"
                  :disabled="!!calcBirthDate"
                  :readonly="!!calcBirthDate"
                  :style="calcBirthDate ? 'background-color: #f8f9fa; cursor: not-allowed;' : ''"
                  :title="calcBirthDate ? 'Дата народження зафіксована з розрахунку калькулятора' : ''"
                />
                <small v-if="calcBirthDate" class="text-muted" style="font-size: 11px;">
                  Зафіксовано з калькулятора
                </small>
                <small class="text-danger d-block" v-if="submitCheck && !insured.dateBirth">
                  Вкажіть дату народження
                </small>
                <small class="text-danger d-block" v-if="insuredErrorTaxNumber">
                  ІПН та Дата народження не співпадають
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <citySearch
                  :citySelect="insuredCitySelect"
                  :cityStore="insuredCityStore"
                />
                <small class="text-danger d-block" v-if="submitCheck && !insured.city">
                  Оберіть місто
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <input type="text" class="form-control" v-model="insured.street" placeholder="Вулиця" />
              </div>
              <div class="col-md-6 mb-3">
                <div class="row">
                  <div class="col-6"><input type="text" class="form-control" v-model="insured.house" placeholder="Номер будинку" /></div>
                  <div class="col-6"><input type="text" class="form-control" v-model="insured.apartment" placeholder="Номер квартири" /></div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  :class="['form-control', {'is-invalid': submitCheck && !isInsuredChild && (!insured.phone || insured.phone.length < 19)}]"
                  v-model="insured.phone"
                  :placeholder="isInsuredChild ? '+38 (0##) ###-##-## (необов\'язково)' : '+38 (0##) ###-##-##'"
                  v-mask="'+38 (0##) ###-##-##'"
                />
                <small class="text-danger d-block" v-if="submitCheck && !isInsuredChild && (!insured.phone || insured.phone.length < 19)">
                  Вкажіть коректний номер телефону (+38 (0XX) XXX-XX-XX)
                </small>
              </div>
              <div class="col-md-6 mb-3">
                <input
                  type="text"
                  class="form-control"
                  v-model="insured.mail"
                  :placeholder="isInsuredChild ? 'Email (необов\'язково)' : 'Email на який отримаєте поліс'"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="order__block mb-4" v-if="!isInsuredSame">
          <div class="order__block-header text-center py-2">
            <strong>Заповніть один з документів застрахованої особи</strong>
          </div>
          <div class="p-4">
            <DocumentsBlock
              ref="insuredDocumentsBlock"
              :productType="12"
              :offerInfo="offerInfo"
              :searchInfo="searchInfo"
              :documentation="insured.documentation"
              :submitCheck="submitCheck"
              :withoutIdentificationCode="insured.withoutIdentificationCode"
              :dateBirth="insured.dateBirth"
              :privileges="false"
            ></DocumentsBlock>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-6 mb-2">
            <button class="btn btn-primary w-100 py-3" style="background-color: #007bff; border-color: #007bff; font-weight: 500;" @click.prevent="submitOrder('next')" v-loading="loading">
              Перейти до наступного кроку
            </button>
          </div>
          <div class="col-md-6 mb-2">
            <button class="btn btn-light w-100 py-3" style="background: #f8f9fa; border: 1px solid #ddd; color: #6c757d; font-weight: 500;" @click.prevent="submitOrder('save')" v-loading="loading">
              Зберегти чернетку
            </button>
          </div>
        </div>
        <div class="memo-banner">
          <h3 class="memo-banner__title">Що робити при страховому випадку?</h3>
          <a v-if="isIngo(parseInt(offerInfo.ex_id))" target="_blank" href="https://ingo.ua/insurance-cases/neshhasnij-vipadok" class="memo-banner__btn">Завантажити пам'ятку</a>
          <a v-else href="#" class="memo-banner__btn">Завантажити пам'ятку</a>
        </div>
      </div>

      <!-- Right Sidebar with details -->
      <div class="col-lg-4 mt-4 mt-lg-0">
        <div class="order-sidebar p-4 mb-4" style="border: 1px solid #ddd; border-radius: 8px; background: #fff;">
          <div class="font-weight-bold mb-3" style="font-size: 18px;">Ваш поліс</div>
          <hr class="mb-3">

          <div class="text-muted small mb-1">Місце реєстрації</div>
          <div class="font-weight-bold mb-3">{{ !searchInfo.countryId || searchInfo.countryId == 1 ? 'Україна' : 'Весь світ (за винятком України)' }}</div>

          <div class="text-muted small mb-1">Термін дії</div>
          <div class="font-weight-bold mb-3">{{ formatPeriod(searchInfo.period || offerInfo.period || offerInfo.term) }}</div>

          <div class="text-muted small mb-1">Початок дії договору</div>
          <div class="font-weight-bold mb-3">{{ searchInfo.startDate || offerInfo.fromDate || offerInfo.startDate }}</div>

          <div class="text-muted small mb-1">Період дії страхового захисту</div>
          <div class="font-weight-bold mb-3">{{ formatProtectionPeriod(searchInfo.protectionPeriod) }}</div>

          <div class="text-muted small mb-1">Дата народження застрахованої особи</div>
          <div class="font-weight-bold mb-3">{{ searchInfo.birthDate || payer.dateBirth }}</div>

          <div class="text-muted small mb-1">Загальна страхова сума</div>
          <div class="font-weight-bold mb-3">{{ searchInfo.sum || searchInfo.insuranceSum || offerInfo.insuranceSum || offerInfo.amount }} грн</div>

          <div class="text-muted small mb-1">Фактори що впливають на фінальну вартість</div>
          <div class="font-weight-bold mb-3">{{ activeFactorsText }}</div>

          <div class="text-muted small mb-1">Страхові ризики</div>
          <div class="font-weight-bold mb-3">{{ coveredRisksText }}</div>

          <hr>

          <div class="text-muted small mb-1">Загальна вартість</div>
          <div class="text-warning font-weight-bold" style="font-size: 28px;">{{ offerInfo.price }} <span style="font-size: 18px; color: #333;">грн</span></div>
        </div>

        <div class="order-sidebar p-4" style="border: 1px solid #ddd; border-radius: 8px; background: #f8f9fa;">
          <h5 class="mb-4 font-weight-bold">Ми гарантуємо</h5>
          <div class="d-flex align-items-center mb-3">
            <div class="mr-3" style="width: 32px; text-align: center;">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.66699 16H6.66699" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M25.333 16H29.333" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 2.66797V6.66797" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 25.332V29.332" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.9993 25.3346C21.154 25.3346 25.3327 21.156 25.3327 16.0013C25.3327 10.8466 21.154 6.66797 15.9993 6.66797C10.8447 6.66797 6.66602 10.8466 6.66602 16.0013C6.66602 21.156 10.8447 25.3346 15.9993 25.3346Z" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="font-weight-500">Точні та вигідні ціни</span>
          </div>
          <div class="d-flex align-items-center mb-3">
            <div class="mr-3" style="width: 32px; text-align: center;">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.0007 29.3346H8.00065C7.29341 29.3346 6.61513 29.0537 6.11503 28.5536C5.61494 28.0535 5.33398 27.3752 5.33398 26.668V5.33465C5.33398 4.6274 5.61494 3.94912 6.11503 3.44903C6.61513 2.94893 7.29341 2.66798 8.00065 2.66798H18.6673C19.0898 2.66694 19.5084 2.74959 19.8988 2.91116C20.2892 3.07272 20.6438 3.31001 20.942 3.60931L25.726 8.39331C26.0253 8.69154 26.2626 9.04609 26.4241 9.4365C26.5857 9.82692 26.6684 10.2455 26.6673 10.668V18.668" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M18.666 2.66797V9.33464C18.666 9.68826 18.8065 10.0274 19.0565 10.2774C19.3066 10.5275 19.6457 10.668 19.9993 10.668H26.666" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19 26.6667L21.6667 29.3333L27 24" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="font-weight-500">Оригінальну страховку</span>
          </div>
          <div class="d-flex align-items-center">
            <div class="mr-3" style="width: 32px; text-align: center;">
              <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 13H5C5.70724 13 6.38552 13.281 6.88562 13.781C7.38572 14.2811 7.66667 14.9594 7.66667 15.6667V19.6667C7.66667 20.3739 7.38572 21.0522 6.88562 21.5523C6.38552 22.0524 5.70724 22.3333 5 22.3333H3.66667C2.95942 22.3333 2.28115 22.0524 1.78105 21.5523C1.28095 21.0522 1 20.3739 1 19.6667V13ZM1 13C1 11.4241 1.31039 9.86371 1.91345 8.4078C2.5165 6.95189 3.40042 5.62902 4.51472 4.51472C5.62902 3.40042 6.95189 2.5165 8.4078 1.91345C9.86371 1.31039 11.4241 1 13 1C14.5759 1 16.1363 1.31039 17.5922 1.91345C19.0481 2.5165 20.371 3.40042 21.4853 4.51472C22.5996 5.62902 23.4835 6.95189 24.0866 8.4078C24.6896 9.86371 25 11.4241 25 13M25 13V19.6667C25 20.3739 24.719 21.0522 24.219 21.5523C23.7189 22.0524 23.0406 22.3333 22.3333 22.3333H21C20.2928 22.3333 19.6145 22.0524 19.1144 21.5523C18.6143 21.0522 18.3333 20.3739 18.3333 19.6667V15.6667C18.3333 14.9594 18.6143 14.2811 19.1144 13.781C19.6145 13.281 20.2928 13 21 13H25Z" stroke="#0A77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="font-weight-500">Рішення будь-якого питання</span>
          </div>
        </div>
      </div>
    </div>

    <clients-fill-data-func
        :show-fill-client-data-modal="showFillClientDataModal"
        :clien-data="selectedPibInn"
        :search-info="searchInfo"
        :offer-info="offerInfo"
        :product-type="'accident'"
        @close="showFillClientDataModal = false"
        @save="saveFillData"/>
  </div>
</template>

<script>
import moment from 'moment';
import { orderAccident } from '@/api/orderAccident';
import { fetchOrder } from '@/entities/insurance/api';
import DocumentsBlock from '../../components/app/forms/DocumentsBlock.vue';
import ClientsFillDataFunc from '@/components/app/clients/clientsFillDataFunc.vue';
import citySearch from '@/components/app/forms/CitySearch.vue';
import {getData} from "@/api/client";
import {ValidateForm} from "@/shared/lib/form";
import {CompanyLogic} from "@/shared/lib/insurance";
import {formatAccidentPeriod} from '@/views/accident/data/accidentPeriods';
import {formatCoveredRisksCount} from '@/views/accident/data/accidentRisks';

export default {
  name: 'AccidentSteps',
  components: {
    DocumentsBlock,
    ClientsFillDataFunc,
    citySearch
  },
  mixins:[ CompanyLogic ],
  data() {
    return {
      insuredsList: { payer: [] },
      insuredsListBySurname: { payer: [] },
      isLoadInsuredsList: false,
      isLoadInsuredsListBySurname: false,
      timer: null,
      fetchClientsTimeout: null,
      isfillData: false,

      showFillClientDataModal: false,
      selectedPibInn: null,
      submitCheck: false,
      loading: false,
      orderId: null,
      isInsuredSame: true,
      payer: {
        isNewClient: false,
        isRegularClient: false,
        isPublicPerson: false,
        isNationalMinority: false,
        surname: '',
        name: '',
        patronymic: '',
        identificationCode: '',
        withoutIdentificationCode: false,
        dateBirth: '',
        phone: '',
        mail: '',
        city: null,
        street: '',
        house: '',
        apartment: '',
        documentation: {
          type: 1,
          serial: '',
          number: '',
          dateOfIssue: '',
          endDateOfIssue: '',
          issuedBy: '',
          unzr: '',
          isID: false
        }
      },
      insured: {
        surname: '',
        name: '',
        patronymic: '',
        identificationCode: '',
        withoutIdentificationCode: false,
        dateBirth: '',
        phone: '',
        mail: '',
        city: null,
        street: '',
        house: '',
        apartment: '',
        documentation: {
          type: 1,
          serial: '',
          number: '',
          dateOfIssue: '',
          endDateOfIssue: '',
          issuedBy: '',
          unzr: '',
          isID: false
        }
      }
    };
  },
  computed: {
    offerInfo() {
      return this.$store.getters.GET_ACCIDENT_INFO_OFFER || {};
    },
    searchInfo() {
      return this.$store.getters.GET_SEARCH_ACCIDENT_PARAMS || {};
    },
    calcBirthDate() {
      return (this.searchInfo && this.searchInfo.birthDate) ? this.searchInfo.birthDate : '';
    },
    activeFactorsText() {
      const s = this.searchInfo || {};
      const factors = [];
      if (s.warRisk || (Array.isArray(s.activeFactors) && s.activeFactors.includes('warRisk')) || s.activeFactor === 'warRisk') {
        factors.push('Воєнні ризики');
      }
      if ((s.sportType && s.sportType !== 'none' && s.sportType !== '140995') || s.sportGroup || (Array.isArray(s.activeFactors) && s.activeFactors.includes('sport')) || s.activeFactor === 'sport') {
        let sportText = 'Спорт';
        if (s.sportName) {
          sportText = `Спорт (${s.sportName})`;
        } else if (s.sportGroup) {
          sportText = `Спорт (Група ${s.sportGroup})`;
        } else if (['1409218', '1409219'].includes(String(s.sportType))) {
          sportText = 'Спорт (Група S0)';
        } else if (['1409221', '1409220'].includes(String(s.sportType))) {
          sportText = 'Спорт (Група S1)';
        } else if (['1409222', '1409223'].includes(String(s.sportType))) {
          sportText = 'Спорт (Група S2)';
        } else if (['1409224', '1409225'].includes(String(s.sportType))) {
          sportText = 'Спорт (Група SE)';
        }
        factors.push(sportText);
      }
      if (!this.isInsuredChild && ((s.profession && s.profession !== 'none' && s.profession !== '1412260') || (Array.isArray(s.activeFactors) && s.activeFactors.includes('profession')) || s.activeFactor === 'profession')) {
        factors.push('Професія');
      }
      if (factors.length === 0) {
        return 'Без підвищеного ризику';
      }
      return factors.join(', ');
    },
    coveredRisksText() {
      if (!this.searchInfo) return 'Базові (всі)';
      const count = formatCoveredRisksCount(this.searchInfo.accidentRisks || this.searchInfo.accident || this.searchInfo);
      return count ? `${count} обрано` : 'Базові (всі)';
    },
    payerErrorTaxNumber() {
      if (this.payer.withoutIdentificationCode || this.payer.identificationCode === '0000000000') {
        return false;
      }
      if (!this.payer.identificationCode || !this.payer.dateBirth) {
        return false;
      }
      if (this.payer.identificationCode.length === 10 && this.payer.dateBirth.length === 10) {
        return !this.validateTaxNumber(this.payer.identificationCode, this.payer.dateBirth);
      }
      return false;
    },
    insuredErrorTaxNumber() {
      if (this.isInsuredSame) {
        return false;
      }
      if (this.insured.withoutIdentificationCode || this.insured.identificationCode === '0000000000') {
        return false;
      }
      if (!this.insured.identificationCode || !this.insured.dateBirth) {
        return false;
      }
      if (this.insured.identificationCode.length === 10 && this.insured.dateBirth.length === 10) {
        return !this.validateTaxNumber(this.insured.identificationCode, this.insured.dateBirth);
      }
      return false;
    },
    isInsuredChild() {
      const bDate = this.calcBirthDate || this.insured.dateBirth;
      if (!bDate || bDate.length !== 10) return false;
      const m = moment(bDate, 'DD.MM.YYYY', true);
      if (!m.isValid()) return false;
      return moment().diff(m, 'years') < 18;
    },
    payerCityStore() {
      return this.payer.city;
    },
    insuredCityStore() {
      return this.insured.city;
    }
  },
  async created() {
    this.$store.dispatch('initSearchAccidentParams');
    this.$store.dispatch('initAccidentInfoOrder');

    const isFromProlongation = this.$route.query?.from === 'prolongation';
    const isFromHistory = this.$route.query?.from === 'history';
    const routeOrderId = this.$route.query.orderId;

    if (isFromProlongation || isFromHistory || routeOrderId) {
      this.$store.dispatch('initAccidentFullInfoOrder');
    } else {
      this.$store.commit('CLEAR_ACCIDENT_FULL_ORDER');
    }

    if (routeOrderId && (!this.$store.getters.GET_ACCIDENT_INFO_OFFER || !this.$store.getters.GET_ACCIDENT_INFO_OFFER.offerId)) {
      try {
        const response = await fetchOrder(routeOrderId, 12);
        const order = Array.isArray(response) ? response[0] : (response?.data || response);
        if (order) {
          const clientRequest = order.clientRequest || order.client_request || {};
          const clientOffer = clientRequest.offerInfo || order.accidentOffer || {};
          const clientSearch = clientRequest.searchInfo || {};
          const clientPayer = clientRequest.payer || {};
          const clientInsured = clientRequest.insured || {};

          if (clientOffer && (clientOffer.offerId || clientOffer.id)) {
            this.$store.commit('SET_ACCIDENT_INFO_OFFER', clientOffer);
          }
          if (clientSearch && clientSearch.startDate) {
            this.$store.commit('SET_SEARCH_ACCIDENT_PARAMS', clientSearch);
          }
          const restoredOrder = {
            orderId: routeOrderId,
            offerInfo: clientOffer,
            searchInfo: clientSearch,
            payer: clientPayer,
            insured: clientInsured
          };
          this.$store.commit('SET_ACCIDENT_FULL_ORDER', restoredOrder);
        }
      } catch (e) {
        console.error('Error restoring order in steps', e);
      }
    }

    const existingOrder = (isFromProlongation || isFromHistory || routeOrderId)
      ? this.$store.getters.GET_ACCIDENT_FULL_ORDER
      : null;
    if (existingOrder) {
      if ((!this.$store.getters.GET_ACCIDENT_INFO_OFFER || !this.$store.getters.GET_ACCIDENT_INFO_OFFER.offerId) && existingOrder.offerInfo) {
        this.$store.commit('SET_ACCIDENT_INFO_OFFER', existingOrder.offerInfo);
      }
      if ((!this.$store.getters.GET_SEARCH_ACCIDENT_PARAMS || !this.$store.getters.GET_SEARCH_ACCIDENT_PARAMS.startDate) && existingOrder.searchInfo) {
        this.$store.commit('SET_SEARCH_ACCIDENT_PARAMS', existingOrder.searchInfo);
      }
    }
  },
  mounted() {
    if (!this.offerInfo || !this.searchInfo || (!this.offerInfo.offerId && !this.offerInfo.id)) {
      this.$router.push({ name: 'accidentSearch' });
      return;
    }

    const isFromProlongation = this.$route.query?.from === 'prolongation';
    const isFromHistory = this.$route.query?.from === 'history';
    const routeOrderId = this.$route.query.orderId;
    const existingOrder = (isFromProlongation || isFromHistory || routeOrderId)
      ? this.$store.getters.GET_ACCIDENT_FULL_ORDER
      : null;
    this.orderId = routeOrderId || (isFromProlongation ? null : (existingOrder?.orderId || null));

    if (this.isInsuredChild) {
      this.isInsuredSame = false;
      this.insured.dateBirth = this.calcBirthDate;
      if (existingOrder && existingOrder.payer) {
        this.payer = JSON.parse(JSON.stringify(existingOrder.payer));
      }
      if (this.payer.dateBirth === this.calcBirthDate) {
        this.payer.dateBirth = '';
      }
      if (existingOrder && existingOrder.insured && (existingOrder.insured.name || existingOrder.insured.surname)) {
        this.insured = JSON.parse(JSON.stringify(existingOrder.insured));
        this.insured.dateBirth = this.calcBirthDate;
        if (this.insured.identificationCode === '0000000000') {
          this.insured.withoutIdentificationCode = true;
          this.insured.identificationCode = '';
        }
      }
      if (!this.insured.identificationCode) {
        this.insured.withoutIdentificationCode = true;
      }
      if (!this.insured.documentation || !this.insured.documentation.number) {
        this.insured.documentation.type = 14; // DOCUMENT_BIRTH_CERTIFICATE
      }
    } else if (existingOrder && existingOrder.payer && (existingOrder.payer.name || existingOrder.payer.surname || existingOrder.payer.phone)) {
      this.payer = JSON.parse(JSON.stringify(existingOrder.payer));
      if (this.payer.documentation && this.payer.documentation.type && isNaN(this.payer.documentation.type)) {
        const docItem = this.$store?.getters?.DOCUMENTS_TYPES?.find(d => d.id === this.payer.documentation.type);
        if (docItem) {
          this.payer.documentation.type = docItem.uid;
        }
      }
      if (existingOrder.insured && (existingOrder.insured.name || existingOrder.insured.surname) && existingOrder.insured.name !== existingOrder.payer.name) {
        this.insured = JSON.parse(JSON.stringify(existingOrder.insured));
        if (this.insured.documentation && this.insured.documentation.type && isNaN(this.insured.documentation.type)) {
          const docItem = this.$store?.getters?.DOCUMENTS_TYPES?.find(d => d.id === this.insured.documentation.type);
          if (docItem) {
            this.insured.documentation.type = docItem.uid;
          }
        }
        this.isInsuredSame = false;
      } else {
        this.isInsuredSame = true;
      }
    } else {
      if (this.calcBirthDate) {
        this.payer.dateBirth = this.calcBirthDate;
        this.insured.dateBirth = this.calcBirthDate;
      }
    }

    if (this.calcBirthDate) {
      if (this.isInsuredSame && !this.isInsuredChild) {
        this.payer.dateBirth = this.calcBirthDate;
      }
      this.insured.dateBirth = this.calcBirthDate;
    }

    if (this.payer.city && typeof this.payer.city !== 'object') {
      this.payer.city = null;
    }
    if (this.insured.city && typeof this.insured.city !== 'object') {
      this.insured.city = null;
    }
  },
  watch: {
    payer: {
      deep: true,
      handler() {
        this.saveDraftLocal();
      }
    },
    insured: {
      deep: true,
      handler() {
        this.saveDraftLocal();
      }
    },
    isInsuredSame: {
      handler(val) {
        if (this.isInsuredChild) {
          this.isInsuredSame = false;
          return;
        }
        if (this.calcBirthDate) {
          if (val) {
            this.payer.dateBirth = this.calcBirthDate;
          }
          this.insured.dateBirth = this.calcBirthDate;
        }
        this.saveDraftLocal();
      }
    },
    'payer.dateBirth': function(newVal) {
      if (this.isInsuredSame && !this.isInsuredChild && this.calcBirthDate && newVal !== this.calcBirthDate) {
        this.$nextTick(() => {
          this.payer.dateBirth = this.calcBirthDate;
        });
      }
    },
    'insured.dateBirth': function(newVal) {
      if (this.calcBirthDate && newVal !== this.calcBirthDate) {
        this.$nextTick(() => {
          this.insured.dateBirth = this.calcBirthDate;
        });
      }
    },
    'payer.surname': async function (newValue, oldValue) {
      if (this.isfillData == true) return;
      if (newValue && newValue.length >= 3) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(async () => {
          this.isLoadInsuredsListBySurname = true;
          await this.fetchClients(newValue, 'surname');
        }, 500);
      } else {
        this.insuredsListBySurname = { payer: [] };
        this.isLoadInsuredsListBySurname = false;
      }
    },
    'payer.identificationCode': async function (newValue, oldValue) {
      if (this.isfillData == true) return;
      if (!this.isInsuredSame && newValue && newValue.length === 10) {
        const taxDate = moment('01.01.1900', 'DD.MM.YYYY').add(newValue.substr(0, 5) - 1, 'day');
        if (taxDate.isValid()) {
          this.payer.dateBirth = taxDate.format('DD.MM.YYYY');
        }
      }
      if (newValue && newValue.length >= 2) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(async () => {
          this.isLoadInsuredsList = true;
          await this.fetchClients(newValue, 'identificationCode');
        }, 500);
      } else {
        this.insuredsList = { payer: [] };
        this.isLoadInsuredsList = false;
      }
    },
  },
  methods: {
    validateTaxNumber(tax_number, date) {
      if (!tax_number || tax_number === '0000000000' || !date || tax_number.length !== 10 || date.length !== 10) {
        return true;
      }
      let tax_numberDate = moment('01.01.1900', 'DD.MM.YYYY').add(tax_number.substr(0, 5) - 1, 'day');
      let birthDate = moment(date, 'DD.MM.YYYY');

      return tax_numberDate.isValid() && birthDate.isValid()
        && tax_numberDate.isSame(birthDate, 'year')
        && tax_numberDate.isSame(birthDate, 'month')
        && tax_numberDate.isSame(birthDate, 'day');
    },
    onPayerWithoutInnChange() {
      if (this.payer.withoutIdentificationCode) {
        this.payer.identificationCode = '';
      }
    },
    onInsuredWithoutInnChange() {
      if (this.insured.withoutIdentificationCode) {
        this.insured.identificationCode = '';
      }
    },
    payerCitySelect(data) {
      if (!data || !data.city) return;
      if (this.payer.city && (this.payer.city === data.city || (this.payer.city.id && this.payer.city.id === data.city.id))) {
        return;
      }
      this.payer.city = data.city;
    },
    insuredCitySelect(data) {
      if (!data || !data.city) return;
      if (this.insured.city && (this.insured.city === data.city || (this.insured.city.id && this.insured.city.id === data.city.id))) {
        return;
      }
      this.insured.city = data.city;
    },
    formatPeriod(period) {
      return formatAccidentPeriod(period);
    },
    formatProtectionPeriod(period) {
      if (!period || period === '24_7') return '24/7';
      if (period === 'study_work_hours' || period === 'working_hours') return 'Під час учбових занять / службових обов’язків';
      if (period === 'sport_hours') return 'Під час занять спортом/змагань';
      return period;
    },
    saveDraftLocal() {
      if (!this.offerInfo || !this.searchInfo) return;
      let orderData = this.getOrderData();
      orderData.orderId = this.orderId || null;
      this.$store.commit('SET_ACCIDENT_FULL_ORDER', orderData);
    },
    async fetchClients(query, type) {
      if (!query) {
        if (type === 'identificationCode') {
          this.insuredsList = { payer: [] };
          this.isLoadInsuredsList = false;
        }
        if (type === 'surname') {
          this.insuredsListBySurname = { payer: [] };
          this.isLoadInsuredsListBySurname = false;
        }
        return;
      }

      let params = {
        'requestType': 'clientsByUserId',
        'searchText': query,
      };

      try {
        let response = await getData(params);
        let items = response?.data?.data?.items || [];
        if (type === 'identificationCode') {
          this.$set(this.insuredsList, 'payer', items);
          if (query.length === 10 && items.length > 0) {
            const exactMatch = items.find(item => String(item.identification_number).trim() === String(query).trim()) || (items.length === 1 ? items[0] : null);
            if (exactMatch && (!this.payer.surname || this.clientId !== exactMatch.id)) {
              this.selectInsuredInfo(exactMatch);
            }
          }
        } else if (type === 'surname') {
          this.$set(this.insuredsListBySurname, 'payer', items);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoadInsuredsList = false;
        this.isLoadInsuredsListBySurname = false;
      }
    },
    selectInsuredInfo(insured) {
      this.isfillData = true;
      this.clientId = insured.id;
      this.$store.commit('SET_CLIENT', insured.id);

      let selectDocument = false;
      let selectTourists = false;

      if (insured.documents && insured.documents.length > 0) {
        selectDocument = insured.documents[0];
      }

      let params = {
        "selectPibInn": insured,
        "selectDocument": selectDocument,
        "selectTourists": selectTourists,
      };

      this.saveFillData(params);
    },

    fillClientData() {
      this.selectedPibInn = null;
      this.showFillClientDataModal = true;
    },
    saveFillData(params) {
      this.showFillClientDataModal = false;
      this.isfillData = true;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.fillFormFromClientData(params.selectPibInn, params.selectTourists, params.selectDocument);
      this.insuredsList = { payer: [] };
      this.insuredsListBySurname = { payer: [] };
      setTimeout(() => {
        this.isfillData = false;
      }, 1000);
    },
    fillFormFromClientData(selectPibInn, selectTourists, selectDocument) {
      this.$store.commit('SET_CLIENT', selectPibInn.id);

      this.payer.identificationCode = selectPibInn.identification_number;
      if (selectPibInn.fio) {
        let fio = selectPibInn.fio.split(' ');
        this.payer.surname = fio[0] || '';
        this.payer.name = fio[1] || '';
        this.payer.patronymic = fio[2] || '';
      }
      this.payer.phone = selectPibInn.phone;
      this.payer.mail = selectPibInn.email;

      if (this.isInsuredSame && this.calcBirthDate) {
        this.payer.dateBirth = this.calcBirthDate;
      } else if (selectPibInn.date_of_birth) {
        const b = moment(selectPibInn.date_of_birth, ['DD-MM-YYYY', 'YYYY-MM-DD', 'DD.MM.YYYY']);
        this.payer.dateBirth = b.isValid() ? b.format('DD.MM.YYYY') : selectPibInn.date_of_birth;
      }
      if (this.calcBirthDate) {
        this.insured.dateBirth = this.calcBirthDate;
      }

      if (selectDocument) {
        this.payer.documentation.type = selectDocument.document_type;
        this.payer.documentation.serial = selectDocument.serial;
        this.payer.documentation.number = selectDocument.number;
        this.payer.documentation.issuedBy = selectDocument.issued_by;
        if (selectDocument.date_of_issue) {
          const d = moment(selectDocument.date_of_issue, ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD.MM.YYYY', 'YYYY-MM-DD HH:mm:ss']);
          this.payer.documentation.dateOfIssue = d.isValid() ? d.format('DD.MM.YYYY') : selectDocument.date_of_issue;
        }
        if (selectDocument.end_date_of_issue) {
          const ed = moment(selectDocument.end_date_of_issue, ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD.MM.YYYY', 'YYYY-MM-DD HH:mm:ss']);
          this.payer.documentation.endDateOfIssue = ed.isValid() ? ed.format('DD.MM.YYYY') : selectDocument.end_date_of_issue;
        }
      }

      this.payer.street = selectPibInn.street || '';
      this.payer.house = selectPibInn.house || '';
      this.payer.apartment = selectPibInn.flat || '';
      this.payer.city = selectPibInn.city;

      if (this.isInsuredSame) {
        this.insured.surname = this.payer.surname;
        this.insured.name = this.payer.name;
        this.insured.patronymic = this.payer.patronymic;
        this.insured.phone = this.payer.phone;
        this.insured.mail = this.payer.mail;
        this.insured.identificationCode = this.payer.identificationCode;
        this.insured.withoutIdentificationCode = this.payer.withoutIdentificationCode;
        this.insured.dateBirth = this.payer.dateBirth;
        this.insured.city = this.payer.city;
        this.insured.street = this.payer.street;
        this.insured.house = this.payer.house;
        this.insured.apartment = this.payer.apartment;
        this.insured.documentation = JSON.parse(JSON.stringify(this.payer.documentation));
      }
    },
    getOrderData() {
      const payerCopy = JSON.parse(JSON.stringify(this.payer));
      const insuredCopy = JSON.parse(JSON.stringify(this.isInsuredSame ? this.payer : this.insured));
      if (this.calcBirthDate) {
        if (this.isInsuredSame && !this.isInsuredChild) {
          payerCopy.dateBirth = this.calcBirthDate;
          insuredCopy.dateBirth = this.calcBirthDate;
        } else {
          insuredCopy.dateBirth = this.calcBirthDate;
        }
      }
      if (payerCopy.withoutIdentificationCode) {
        payerCopy.identificationCode = '';
      }
      if (insuredCopy.withoutIdentificationCode || (this.isInsuredChild && !insuredCopy.identificationCode)) {
        insuredCopy.withoutIdentificationCode = true;
        insuredCopy.identificationCode = '';
      }
      if (this.isInsuredChild) {
        const cleanedChildPhone = (insuredCopy.phone || '').replace(/[^0-9]/g, '');
        if (!cleanedChildPhone || cleanedChildPhone.length < 10) {
          insuredCopy.phone = payerCopy.phone;
        }
        if (!insuredCopy.mail || !insuredCopy.mail.trim()) {
          insuredCopy.mail = payerCopy.mail;
        }
      }
      return {
        productType: 12,
        offerId: this.offerInfo.offerId,
        price: this.offerInfo.price,
        searchInfo: JSON.parse(JSON.stringify(this.searchInfo)),
        offerInfo: JSON.parse(JSON.stringify(this.offerInfo)),
        payer: payerCopy,
        insured: insuredCopy
      };
    },
    async submitOrder(actionType) {
      this.submitCheck = true;

      if (this.calcBirthDate) {
        if (this.isInsuredSame && !this.isInsuredChild) {
          this.payer.dateBirth = this.calcBirthDate;
          this.insured.dateBirth = this.calcBirthDate;
        } else {
          this.insured.dateBirth = this.calcBirthDate;
        }
      }
      if (!this.payer.surname) {
        this.$toast.error('Вкажіть прізвище страхувальника');
        return;
      }
      if (!this.payer.name) {
        this.$toast.error('Вкажіть ім\'я страхувальника');
        return;
      }
      if (!this.payer.identificationCode && !this.payer.withoutIdentificationCode) {
        this.$toast.error('Вкажіть ІПН страхувальника або оберіть "Відсутній ІПН"');
        return;
      }
      if (!this.payer.dateBirth) {
        this.$toast.error('Вкажіть дату народження страхувальника');
        return;
      }
      if (this.payerErrorTaxNumber) {
        this.$toast.error('ІПН та Дата народження страхувальника не співпадають');
        return;
      }
      if (!this.payer.city) {
        this.$toast.error('Оберіть місто проживання страхувальника');
        return;
      }
      if (!this.payer.phone || this.payer.phone.length < 19) {
        this.$toast.error('Вкажіть коректний номер телефону страхувальника (+38 (0XX) XXX-XX-XX)');
        return;
      }
      if (!this.payer.mail) {
        this.$toast.error('Вкажіть email для отримання поліса');
        return;
      }

      if (this.payer.dateBirth) {
        const m = moment(this.payer.dateBirth, 'DD.MM.YYYY', true);
        if (m.isValid() && moment().diff(m, 'years') < 18) {
          this.$toast.error('Страхувальник повинен бути від 18 років');
          return;
        }
      }

      if (this.$refs.documentsBlock && this.$refs.documentsBlock.$v && this.$refs.documentsBlock.$v.$invalid) {
        this.$refs.documentsBlock.$v.$touch();
        this.$toast.error('Заповніть обов\'язкові поля документа страхувальника');
        return;
      }

      if (!this.isInsuredSame) {
        if (!this.insured.surname) {
          this.$toast.error('Вкажіть прізвище застрахованої особи');
          return;
        }
        if (!this.insured.name) {
          this.$toast.error('Вкажіть ім\'я застрахованої особи');
          return;
        }
        if (!this.isInsuredChild && !this.insured.identificationCode && !this.insured.withoutIdentificationCode) {
          this.$toast.error('Вкажіть ІПН застрахованої особи або оберіть "Відсутній ІПН"');
          return;
        }
        if (this.insuredErrorTaxNumber) {
          this.$toast.error('ІПН та Дата народження застрахованої особи не співпадають');
          return;
        }
        if (!this.insured.dateBirth) {
          this.$toast.error('Вкажіть дату народження застрахованої особи');
          return;
        }
        if (!this.insured.city) {
          this.$toast.error('Оберіть місто проживання застрахованої особи');
          return;
        }
        if (!this.isInsuredChild) {
          if (!this.insured.phone || this.insured.phone.length < 19) {
            this.$toast.error('Вкажіть коректний номер телефону застрахованої особи');
            return;
          }
        }
        if (this.insured.dateBirth) {
          const m = moment(this.insured.dateBirth, 'DD.MM.YYYY', true);
          if (m.isValid() && moment().diff(m, 'years') < 1) {
            this.$toast.error('Вік застрахованої особи повинен бути від 1 року');
            return;
          }
        }

        if (this.$refs.insuredDocumentsBlock && this.$refs.insuredDocumentsBlock.$v && this.$refs.insuredDocumentsBlock.$v.$invalid) {
          this.$refs.insuredDocumentsBlock.$v.$touch();
          this.$toast.error('Заповніть обов\'язкові поля документа застрахованої особи');
          return;
        }
      }

      this.loading = true;
      try {
          const params = {
              statusId: 1 // draft
          };

          let payerData = JSON.parse(JSON.stringify(this.payer));
          if (payerData.withoutIdentificationCode) {
            payerData.identificationCode = '';
          }

          let insuredData = this.isInsuredSame ? null : JSON.parse(JSON.stringify(this.insured));
          if (insuredData) {
            if (insuredData.withoutIdentificationCode || (this.isInsuredChild && !insuredData.identificationCode)) {
              insuredData.withoutIdentificationCode = true;
              insuredData.identificationCode = '';
            }
            if (this.isInsuredChild) {
              const cleanedChildPhone = (insuredData.phone || '').replace(/[^0-9]/g, '');
              if (!cleanedChildPhone || cleanedChildPhone.length < 10) {
                insuredData.phone = payerData.phone;
              }
              if (!insuredData.mail || !insuredData.mail.trim()) {
                insuredData.mail = payerData.mail;
              }
            }
          }

          let response = await orderAccident(
              this.offerInfo,
              this.searchInfo,
              payerData,
              insuredData,
              this.orderId || null,
              params,
              0,
              this.isInsuredSame
          );

          if (response.data && response.data.data) {
              const orderId = response.data.data[0].id;
              this.orderId = orderId;
              let orderData = this.getOrderData();
              orderData.orderId = orderId;
              this.$store.commit('SET_ACCIDENT_FULL_ORDER', orderData);

              if (actionType === 'next') {
                  this.$router.push({ name: 'accidentFinnaly', query: { orderId: orderId } });
              } else {
                  this.$toast.success('Чернетка успішно збережена.');
              }
          } else {
              this.$toast.error('Помилка створення чернетки');
          }
      } catch (e) {
          this.$toast.error(e.response?.data?.message || 'Помилка при збереженні даних');
      } finally {
          this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.order-accident {
  background: #f7f9fa;
}
.page-title {
  font-size: 24px;
  font-weight: bold;
}
.order__block {
  background: #fff;
  border: 1px solid #e1e8ed;
  border-radius: 8px;
  overflow: hidden;
}
.order__block-header {
  background: #f4f5f7;
  color: #333;
  font-size: 16px;
  border-bottom: 1px solid #e1e8ed;
}
.custom-checkbox label {
  font-size: 14px;
}
.form-control {
  border: 1px solid #dde2e5;
  border-radius: 4px;
  padding: 10px 15px;
  height: auto;
}
.form-control:focus {
  border-color: #007bff;
  box-shadow: none;
}
.font-weight-500 {
  font-weight: 500;
}

.memo-banner {
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://ukasko.ua/images/guarantee/crash-bg.jpg');
  background-color: #4a5568;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  padding: 40px;
  color: white;
  margin-top: 30px;
}
.memo-banner__title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #fff;
}
.memo-banner__btn {
  display: inline-block;
  background: white;
  color: #000;
  padding: 14px 28px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: opacity 0.2s;
}
.memo-banner__btn:hover {
  opacity: 0.9;
  color: #000;
  text-decoration: none;
}
@media (max-width: 768px) {
  .memo-banner {
    padding: 30px 20px;
  }
  .memo-banner__title {
    font-size: 22px;
  }
  .memo-banner__btn {
    display: block;
    text-align: center;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
